import { motion } from "framer-motion";
import { HiArrowRight, HiCheckCircle, HiOutlineCube } from "react-icons/hi";
import SectionTitle from "../components/SectionTitle";
import { products } from "../data/content";
import { fadeInUp, stagger } from "../utils/motion";

function ProductsSection() {
  return (
    <section id="products" className="relative py-24 sm:py-28">
      <div className="section-shell">
        <SectionTitle
          eyebrow="Products"
          title="Ready-To-Customize Project Solutions"
          subtitle="Explore practical software products BeeVerge can customize for schools, libraries, book businesses, garages, and service-based teams."
        />

        <motion.div
          variants={stagger}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.15 }}
          className="grid gap-6 lg:grid-cols-3"
        >
          {products.map((product, index) => (
            <motion.article
              key={product.title}
              variants={fadeInUp}
              whileHover={{ y: -10, scale: 1.01 }}
              transition={{ delay: index * 0.06 }}
              className="glass group flex h-full flex-col overflow-hidden rounded-2xl shadow-glass"
            >
              <div className="relative h-64 overflow-hidden">
                <img
                  src={product.image}
                  alt={product.title}
                  onError={(event) => {
                    event.currentTarget.src =
                      "https://images.pexels.com/photos/5212700/pexels-photo-5212700.jpeg?auto=compress&cs=tinysrgb&w=900";
                  }}
                  className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#05050b] via-[#05050b]/20 to-transparent" />
                <div className="absolute left-4 top-4 inline-flex items-center gap-2 rounded-full border border-cyan-200/25 bg-black/45 px-3 py-2 text-xs font-semibold uppercase tracking-[0.14em] text-cyan-100 backdrop-blur">
                  <HiOutlineCube className="h-4 w-4" />
                  {product.category}
                </div>
              </div>

              <div className="flex flex-1 flex-col p-6">
                <h3 className="text-2xl font-bold leading-tight text-white">{product.title}</h3>
                <p className="mt-4 text-sm leading-7 text-blue-100/78">{product.description}</p>

                <div className="mt-5 space-y-3">
                  {product.features.map((feature) => (
                    <div key={feature} className="flex gap-3 text-sm leading-6 text-blue-100/82">
                      <HiCheckCircle className="mt-1 h-5 w-5 shrink-0 text-cyan-300" />
                      <span>{feature}</span>
                    </div>
                  ))}
                </div>

                <div className="mt-6 rounded-xl border border-cyan-200/15 bg-cyan-300/10 p-4">
                  <p className="text-xs font-semibold uppercase tracking-[0.16em] text-cyan-300">
                    Business Impact
                  </p>
                  <p className="mt-2 text-sm leading-6 text-blue-100/78">{product.impact}</p>
                </div>

                <motion.a
                  href="#contact"
                  whileHover={{ x: 4 }}
                  className="mt-6 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.14em] text-cyan-200 transition hover:text-white"
                >
                  Discuss This Project
                  <HiArrowRight className="h-4 w-4" />
                </motion.a>
              </div>
            </motion.article>
          ))}
        </motion.div>
      </div>
    </section>
  );
}

export default ProductsSection;
